import window from "../WindowExtended";

export const amazonClientId = "amzn1.application-oa2-client.515d5c44015240c6b5fdf2d8f4e837f5";
export const amazonMerchantId = "A2XKX1Y5Q9QU23";
export const amazonPayButtonId = "AmazonPayButtonReact";
export const amazonPayScriptId = "AmazonPayScript";
export const amazonPayAddressContainerId = "AmazonPayAddressWidget";
export const amazonPayWalletContainerId = "AmazonPayWalletWidget";
export const amazonPayAddressReadableContainerId = "AmazonPayAddressReadableWidget";
export const amazonPayWalletReadableContainerId = "AmazonPayWalletReadableWidget";
export const amazonScriptSourceUrl = `https://static-eu.payments-amazon.com/OffAmazonPayments/de/${
  __DEVELOPMENT__ ? "sandbox/lpa" : "lpa"
}/js/Widgets.js`;

export const widgetOptions = {
  design: {
    designMode: "responsive" as "responsive" | "smartphoneCollapsible",
  },
  displayMode: "Edit" as "Edit" | "Read",
  sellerId: amazonMerchantId,
};

export const cancelAmazonPay = (): void => {
  window.amazon.Login.logout();
  window.orderReferenceId = "";
  window.isBillingAgreementAddressSet = window.isBillingAgreementPaymentSet = false;
  document.cookie = "amazon_Login_accessToken=; expires=Thu, 01 Jan 1970 00:00:00 GMT";
};

export const isAmazonLoggedIn = (): boolean => !!document.cookie.split("amazon_Login_accessToken=")[1]?.split(";")[0];
